module.exports = __webpack_public_path__ + "img/ks_down.ef74d43c.png";